// home.js
import React from 'react';
import moment from 'moment';
import ReservationService from '../services/reservation';
import _ from 'lodash';
import config from '../config';
import confirmIcon from '../img/confirm_icon.png';
import departBusIcon from '../img/depart_bus.svg';
import returnBusIcon from '../img/return_bus.svg';
import rightArrow from '../img/rightOrangeArrow.svg';
import rightGrayArrow from '../img/gray-triangle-right.svg';
import Link from './Link/Link';

class TicketConfirmed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departCity: '',
      arriveCity: '',
      returnDepartCity: '',
      returnArriveCity: '',
      departDate: moment().startOf('day'),
      returnDate: moment().startOf('day'),
      departTime: '12:00:00',
      arriveTime: '12:00:00',
      returnTime: '12:00:00',
      returnArriveTime: '12:00:00',
      seats: '',
      departSeatNumbers: '',
      returnSeatNumbers: '',
      departTripCode: null,
      returnTripCode: null,
      confirmationCode: null,
      cities: config.cities
    };
  }

  getStopLabel(stop) {
    return _.find(this.state.cities, {value: stop}).label;
  }

  getStopPickup(stop) {
    return _.find(this.state.cities, {value: stop}).address;
  }

  componentDidMount() {
    window.$("html, body").animate({ scrollTop: 0 }, 'fast');
    let obj = {};
    if(this.props.location.query.departCity) {
      obj.departCity = this.props.location.query.departCity;
    }
    if(this.props.location.query.arriveCity) {
      obj.arriveCity = this.props.location.query.arriveCity;
    }
    if(this.props.location.query.returnDepartCity) {
      obj.returnDepartCity = this.props.location.query.returnDepartCity;
    }
    if(this.props.location.query.returnArriveCity) {
      obj.returnArriveCity = this.props.location.query.returnArriveCity;
    }
    if(this.props.location.query.departStop) {
      obj.depart_stop = this.props.location.query.departStop;
    }
    if(this.props.location.query.arriveStop) {
      obj.arrive_stop = this.props.location.query.arriveStop;
    }
    if(this.props.location.query.departStop1) {
      obj.depart_stop1 = this.props.location.query.departStop1;
    }
    if(this.props.location.query.arriveStop1) {
      obj.arrive_stop1 = this.props.location.query.arriveStop1;
    }
    if(this.props.location.query.departDate) {
      obj.departDate = this.props.location.query.departDate;
    }
    if(this.props.location.query.returnDate) {
      obj.returnDate = this.props.location.query.returnDate;
    }
    if(this.props.location.query.departTime) {
      obj.departTime = this.props.location.query.departTime;
    }
    if(this.props.location.query.returnTime) {
      obj.returnTime = this.props.location.query.returnTime;
    }

    if(this.props.location.query.departTime) {
      obj.arriveTime = this.props.location.query.arriveTime;
    }
    if(this.props.location.query.returnTime) {
      obj.returnArriveTime = this.props.location.query.returnArriveTime;
    }

    if(this.props.location.query.departTime) {
      obj.departTime = this.props.location.query.departTime;
    }
    if(this.props.location.query.returnTime) {
      obj.returnTime = this.props.location.query.returnTime;
    }
    if(this.props.location.query.seats) {
      obj.seats = parseInt(this.props.location.query.seats);
    }
    if(this.props.location.query.departSeatNumbers) {
      obj.departSeatNumbers = decodeURIComponent(this.props.location.query.departSeatNumbers).replace(/,/g, ', ');
    }
    if(this.props.location.query.returnSeatNumbers) {
      obj.returnSeatNumbers = decodeURIComponent(this.props.location.query.returnSeatNumbers).replace(/,/g, ', ');
    }
    if(this.props.location.query.departTripCode) {
      obj.departTripCode = this.props.location.query.departTripCode;
    }
    if(this.props.location.query.returnTripCode) {
      obj.returnTripCode = this.props.location.query.returnTripCode;
    }
    if(this.props.location.query.confirmationCode) {
      obj.confirmationCode = this.props.location.query.confirmationCode;
    }
    if(this.props.location.query.refundCredit) {
      obj.refundCredit = parseFloat(this.props.location.query.refundCredit);
    }
    if(this.props.location.query.refundPoints) {
      obj.refundPoints = parseInt(this.props.location.query.refundPoints, 10);
    }
    if(Object.keys(obj).length > 0) {
      this.setState(obj);
    }
  }

  createBlob(data, filename){
    var blob = new Blob([data], {type: 'application/pdf'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, filename);
    }
    else {
      var blobURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);
      if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }
  }

  download(code) {
    ReservationService.download(code)
    .then((result) => {
      this.createBlob(result.body, 'ticket.pdf');
    })
    .catch((err) => {
      this.setState({loading: false, error: err.toString()});
    });
  }

  render() {
  	return (
      <div>
        <div className="editTrip addGiftWrapper tickets-confirmed">
          <div className="content-body">
              <div className="card ticket-confirmed-card">
                <div className="card-header">
                  <h3>Your Ticket Purchase Was Successful</h3>
                </div>
                <div className='heading'>
                      <p>Order Details</p>
                </div>
                {(this.state.refundCredit > 0 || this.state.refundPoints > 0) && <div style={{background: '#fff8e6', border: '1px solid #f0d998', borderRadius: '4px', padding: '10px 14px', margin: '10px 16px', fontSize: '14px', lineHeight: '1.5'}}>
                  <strong>Refund from your original reservation:</strong>{' '}
                  {this.state.refundCredit > 0 && <span>${this.state.refundCredit.toFixed(2)} has been added to your account as credit{this.state.refundPoints > 0 ? ' and ' : '.'}</span>}
                  {this.state.refundPoints > 0 && <span>{this.state.refundPoints} points have been returned to your account.</span>}
                  {this.state.refundCredit > 0 && <span> The credit covers seat add-ons and other cash amounts you paid on the original reservation, and can be applied to a future booking.</span>}
                </div>}
                <div className="clearfix">
                  {this.state.departTripCode && <div className="trip-row">
                    <div className="grid">
                      <div className='ticketInfo'>
                        <div className='grid sub-grid-depart'>
                          <div>Seat/s</div>
                          <span>{this.state.seats}</span>
                        </div>
                        {this.state.departSeatNumbers && <div className='grid sub-grid-depart'>
                          <div>Seat Numbers</div>
                          <span>{this.state.departSeatNumbers}</span>
                        </div>}
                        <div className='grid sub-grid-depart'>
                          <div>Ticket ID</div>
                          <span>{config.formatReservationNumber(this.state.departTripCode)}</span>
                        </div>
                      </div>
                    <div className='otherDetails'>
                    <div className='grid sub-grid-depart'>
                        <div><img src={departBusIcon} height="20px" width="20px" alt="Bus departing for outbound journey confirmation"/></div>
                        <div className='title'>Departing trip</div>
                      </div>
                      <div className='grid sub-grid-depart'>
                        <div></div>
                        <div>
                          <div className='grid-stops'>
                            <span className='cityDetail'>
                              {this.getStopLabel(this.state.departCity)}
                            </span>
                            <span>
                              <img src={rightArrow} width="20px" height={"20px"} alt="Travel route direction from departure to arrival city"/>
                            </span>
                           <span className='cityDetail'>
                            {this.getStopLabel(this.state.arriveCity)}
                           </span>
                           </div>
                        </div>
                      </div>
                      <div className='grid sub-grid-depart-3'>
                        <div></div>
                        <div className='grid time'>
                          {moment(this.state.departDate).format('MMM DD')}
                          <span className="bold">{moment(this.state.departTime, 'HH:mm:ss').format('hh:mm a')}</span>
                          <img src={rightGrayArrow} width="10px" height="10px" alt="Time progression from departure to arrival"/>
                          <span className="bold">{moment(this.state.arriveTime, 'HH:mm:ss').format('hh:mm a')}</span>
                        </div>
                      </div>
                    </div>
                    <div className="download-btn">
                      <button type="button" className="btn btn-blue" onClick={this.download.bind(this, this.state.departTripCode)}>Download PDF</button>
                    </div>
                    </div>
                  </div>}
                  {
                    this.state.returnTripCode &&
                    <div className="trip-row first-trip">
                      <div className="grid">


                    <div className='ticketInfo'>
                        <div className='grid sub-grid-depart'>
                          <div>Seat/s</div>
                          <span>{this.state.seats}</span>
                        </div>
                        {this.state.returnSeatNumbers && <div className='grid sub-grid-depart'>
                          <div>Seat Numbers</div>
                          <span>{this.state.returnSeatNumbers}</span>
                        </div>}
                        <div className='grid sub-grid-depart'>
                          <div>Ticket ID</div>
                          <span>{config.formatReservationNumber(this.state.returnTripCode)}</span>
                        </div>
                      </div>

                      <div className='otherDetails'>

                        <div className='grid sub-grid-depart'>
                          <div><img src={returnBusIcon} height="20px" width="20px" alt="Bus returning for return journey confirmation"/></div>
                          <div className='title'>Returning trip</div>
                        </div>

                        <div className='grid sub-grid-depart'>
                        <div></div>
                        <div>
                          <div className='grid-stops'>{this.getStopLabel(this.state.returnDepartCity)}
                            <span><img src={rightArrow} width="20px" height={"20px"} alt="Return route direction from departure to arrival city"/></span>
                           {this.getStopLabel(this.state.returnArriveCity)}</div>
                        </div>
                      </div>


                        <div className='grid sub-grid-depart-3'>
                          <div></div>
                          <div className='grid time'>
                            {moment(this.state.returnDate).format('MMM DD')}
                            <span className="bold">{moment(this.state.returnTime, 'HH:mm:ss').format('hh:mm a')}</span>
                            <img src={rightGrayArrow} width="10px" height="10px" alt="Return trip time progression from departure to arrival"/>
                            <span className="bold">{moment(this.state.returnArriveTime, 'HH:mm:ss').format('hh:mm a')}</span>
                          </div>
                      </div>
                    </div>

                      <div className="download-btn">
                        <button type="button" className="btn btn-blue" onClick={this.download.bind(this, this.state.returnTripCode)}>Download PDF</button>
                      </div>
                      </div>

                    </div>
                  }
                </div>
              </div>
              <div className="text-center be-sure-join">Be Sure to join our <span className="blue-text"><Link target="_blank" to="/rewards" externalLink={true}>Loyalty Rewards Program</Link></span> to earn free travel! Points are credited to your account after you complete your trip.</div>
          </div>
        </div>
      </div>
  	)
  }
}

export default TicketConfirmed;
